export default __webpack_public_path__ + "static/media/user.0e047895.png";